import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { CreditService } from '../credit.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';

import { RxComponent } from 'app/core/components/common/rx.component';
import { SessionService } from 'app/core/services/session.service';

import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ApproveComponent } from '../approve/approve.component';
import { RejectComponent } from '../reject/reject.component';

@Component({
	selector: 'itpx-credit-details',
	templateUrl: './credit-details.component.html',
	styleUrls: ['./credit-details.component.css']
})
export class CreditDetailsComponent extends RxComponent implements OnInit {

	private details: any;
	private id: string;
    private sub: Subscription;
    
    private userGroups: any;

    private fields: Array<any>;
    private buttons=[];

    constructor(
        private service: CreditService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private sessionService: SessionService,
        private modalService: SmartModalService
    ) { 
		super()
	}

    ngOnInit() {

        this.userGroups = this.sessionService.getUserGroups();
       
        if(this.userGroups && this.userGroups.indexOf('credit-application-manager') !== -1) {
            this.buttons.push(
                {
                    title: 'Edit',
                    action: 'edit',
                    icon: 'fa-pencil-square',
                    class: 'btn-primary',
                    disabled: false
                },
                {
                    title: 'Approve',
                    action: 'approve',
                    icon: 'fa-check',
                    class: 'btn btn-success',
                    disabled: false
                },
                {
                    title: 'Reject',
                    action: 'reject',
                    icon: 'fa-times',
                    class: 'btn-danger',
                    disabled: false
                }
            )
		} else if (this.userGroups && this.userGroups.indexOf('credit-application-owner') !== -1) {
            this.buttons.push(
                {
                    title: 'Edit',
                    action: 'edit',
                    icon: 'fa-pencil-square',
                    class: 'btn-primary',
                    disabled: false
                }
            )
        }

		this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
			this.service.getCreditDetails(this.id)
				.subscribe(
					body=> {
                        this.details = body.data;
                        if(this.details.creditDecision) {
                            this.buttons = [];
                        }
					}
                );
        });

        this.fields = this.service.getDetailsFields();
    }

    ngOnDestroy() {
        
    }

    private onAction(action: string) {
        let details = Object.assign({}, this.details);
        if (action == 'edit') {
            this.router.navigate(['/agora/account-data/credit/' + this.id + '/edit' ]);
        } else if (action == 'approve') {
    
            let result =  this.modalService.open(ApproveComponent, details, 'Approve Request')
                .neverError()
                .bindToLifecycle(this)
                .subscribe(
                    data => { 
                        if(data.result == 'success') {
                            this.fetchData();
                        }
                }
            )
           
        } else if (action == 'reject') {
            let result =  this.modalService.open(RejectComponent, details, 'Reject Request')
                .neverError()
                .bindToLifecycle(this)
                .subscribe(
                    data => { 
                        if(data.result == 'success') {
                            this.fetchData();
                        }
                }
        )
        } else {
            return false;
        }
    }

    private fetchData() {
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
			this.service.getCreditDetails(this.id)
				.subscribe(
					body=> {
                        this.details = body.data;
                        if(this.details.creditDecision) {
                            this.buttons = [];
                        }
					}
                );
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/credit/details/credit-details.component.ts